/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 *
 *     DOB -> DATE OF BIRTHDAY
 */

<template>
  <div class="wrapp-dob">
    <div class="block-dob">
      <b-form-group id="groupDob" label-for="dob" class="customer-dob">
        <base-input
        classInput="rounded"
        name="dob"
        :min="endDate"
        :max="startDate"
        v-model="calendarDate"
        :placeholder="$t('address.DoB')"
        type="date"
        :info="$t('customer-must-have-at-least-18-years')"
        :validations="validations"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import filter from 'lodash/filter'
import BaseInput from 'theme/components/Form/BaseInput'

let _startDate = dayjs().subtract(18, 'years')
let startDate = _startDate.format('YYYY-MM-DD')
let _endDate = dayjs(_startDate).subtract(100, 'years')
let endDate = _endDate.format('YYYY-MM-DD')
export default {
  name: 'Dob',
  props: {
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    selectClass: {
      type: String,
      required: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      startDate: startDate,
      endDate: endDate
    }
  },
  computed: {
    calendarDate: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
        return newValue
      }
    },
    validState () {
      let state = null
      for (let validation of this.validations) {
        if (validation.condition) {
          state = false
          break
        }
      }
      return state
    },
    validationsFiltered () {
      return filter(this.validations, { condition: true })
    }
  },
  components: {
    BaseInput
  }
}
</script>
